/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useSelector } from "react-redux";
import React, { useContext, useEffect, useState } from "react";

import environment from "constants/apiConst";
import TableOrder from "components/Tables/TableOrder";
import FormPaisesShow from "../FormShow/FormPaisesShow";
import ConfigurationHeader from "../ConfigurationHeader";
import TbodyPaises from "components/Tables/TbodyPaises";
import Pagination from "components/Pagination/Pagination";
import EditFormPaises from "components/Form/EditFormPaises";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import { __Localitation } from "request/configuration/__Localitation";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";

export const Countries = () => {
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [currentPage, setCurrentPage] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { q = "" } = queryString.parse(location.search);
  const freeZone_id = useSelector((state) => state.auth.dataUser.token);
  const {
    update,
    setFormShow,
    setFormEdit,
    setRequestEdit,
    setRequestDelete,
    setRequestCreate
  } = useContext(ConfigurationCRUDContext);
  // const [isOpenModalNP, openModalNP, closeModalNP] = useModal();

  const TitlePaises = [
    { name: "Código", order: "code_country" },
    { name: "Nombre", order: "name_country" },
    { name: "Mercado", order: "market_country" },
    { name: "Paraíso Fiscal", order: "paradise_country" },
    { name: "Procedencia", order: "source_country" },
    { name: "Destino", order: "destiny_country" },
    { name: "Estado", order: "status_country" },
    { name: "Acciones", order: null }
  ];

  const formEdit = () => {
    return <EditFormPaises />;
  };
  const formShowP = () => {
    return <FormPaisesShow />;
  };

  useEffect(() => {
    setFormShow(formShowP);
    setFormEdit(formEdit);
    setRequestEdit(environment.LOCALITATION_UPDATE);
    setRequestCreate(environment.LOCALITATION_CREATE);
    setRequestDelete(environment.LOCALITATION_DELETE);
  }, [page, q, update]);

  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configCountries", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.GETLOCALITATION,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <>
      <ConfigurationHeader title="Países" />
      <SectionContainerGene>
        <TableOrder
          thead={TitlePaises}
          data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
          setData={setCurrentPage}
          loading={isLoading}
          tbodyData={TbodyPaises}
        />
        {!!maxPage && (
          <Pagination
            page={page}
            setPage={setPage}
            maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
            loading={isLoading}
          />
        )}
      </SectionContainerGene>
    </>
  );
};
